import React, { memo } from 'react';
import StoreDetails from './store-details';


const StorePin = memo(function StorePin({ showPopup, listNumber, location, onStoreChanged }) {
  const handleClose = (e) => {
    e.preventDefault();
    onStoreChanged();
  }

  const handleClick = () => {
    onStoreChanged(location);
  }
  return (
    <div className='pin-container'>
      <div className='pin store-pin' onClick={handleClick}>
        {listNumber}
      </div>
      {showPopup && <div className='pin-popup'>
        <a
          className='close-popup'
          href='#'
          onClick={handleClose}>
          <i className='fas fa-times'></i>
        </a>
        <StoreDetails
          location={location}
          showInfo />
        <div className='point'></div>
      </div>}
    </div>
  )
})

export default StorePin;
